import { render } from "./RenegotiationView.vue?vue&type=template&id=ca050558"
import script from "./RenegotiationView.vue?vue&type=script&lang=js"
export * from "./RenegotiationView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__